import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import { IAssignmentItem, IOrderItem, OrderStatusCategory } from '../../../providers';

import { AssignmentStatusIcon } from './AssignmentStatusIcon';
import { ICON_VARIANT_MAP, StatusIconVariant } from './constants';
import { PlatformAdminApi } from '../../../../../../../services/GrpcService';

interface IOrderAssignmentCellProps {
  assignments?: null | IAssignmentItem[];
  order?: null | IOrderItem;
}

export const OrderAssignmentCell = memo<IOrderAssignmentCellProps>(({ assignments, order }) => (
  <td>
    {assignments
      // eslint-disable-next-line no-nested-ternary
      ?.sort((a, b) => (!a.startAt || !b.startAt ? -1 : new Date(a.startAt) > new Date(b.startAt) ? -1 : 1))
      ?.map((item, i) => {
        const { contractor, status } = item;
        const contractorId = contractor?.id!;
        const key = contractorId || i;

        const isOrderCancelled = order?.statusCategory === OrderStatusCategory.Canceled;

        const iconVariant = status == null || !contractor ? StatusIconVariant.Searching : ICON_VARIANT_MAP[status];
        const showIcon = status == null || !isOrderCancelled;

        const isSearchingContractor = (!contractor || iconVariant === StatusIconVariant.Searching) && !isOrderCancelled;

        const contractorName = contractor?.fullName || '';
        const contractorComponent = contractorId ? (
          <Link to={`/users/contractors/${contractorId}`}>{contractorName}</Link>
        ) : (
          contractorName
        );

        return (
          <div className="font-regular-base" key={key}>
            {contractor?.type} {isSearchingContractor ? 'Ищем исполнителя' : contractorComponent}
            {showIcon && <AssignmentStatusIcon variant={iconVariant} />}
          </div>
        );
      })}
  </td>
));
